function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/ProfileApi";
import * as UserModalComponent from "./UserModalComponent";
import * as UserPasswordModalComponent from "./UserPasswordModalComponent";
import * as UserThumbnailModalComponent from "./UserThumbnailModalComponent";
import * as UserAvatarModalComponent from "./UserAvatarModalComponent";
import * as UserRegenerateModalComponent from "./UserRegenerateModalComponent";
import { ToDateString, NullNumberToBlank } from "../commons/Utility";
import { ApiResultCodes } from "../enum/ApiResultCodes";
import IntlMessage from '../commons/Intl';
import { Label, Action, Profile, Avatar } from '../commons/IntlMessages';
import { ConversionStatuses } from "../enum/ConversionStatuses";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      AcessToken: "",
      Profile: null,
      UserName: "",
      UserMailAddress: "",
      UserModalMode: UserModalComponent.Mode.None,
      UserPasswordModalMode: UserPasswordModalComponent.Mode.None,
      UserThumbnailModalMode: UserThumbnailModalComponent.Mode.None,
      UserAvatarModalMode: UserAvatarModalComponent.Mode.None,
      UserRegenerateModalMode: UserRegenerateModalComponent.Mode.None,
      ErrorMessages: []
    };
    _this.waitLoaded = 0;

    _this.GetProfile();

    return _this;
  }
  /**
   * プロフィール取得
   */


  _createClass(MainComponent, [{
    key: "GetProfile",
    value: function GetProfile() {
      var _this2 = this;

      Api.GetProfile(function (data) {
        _this2.setState({
          AcessToken: data.AccessToken,
          Profile: data.Profile,
          UserName: data.Profile.UserName,
          UserMailAddress: data.Profile.UserMailAddress,
          UserModalMode: UserModalComponent.Mode.None,
          UserPasswordModalMode: UserPasswordModalComponent.Mode.None,
          UserThumbnailModalMode: UserThumbnailModalComponent.Mode.None,
          UserAvatarModalMode: UserAvatarModalComponent.Mode.None,
          UserRegenerateModalMode: UserRegenerateModalComponent.Mode.None,
          ErrorMessages: []
        }, function () {
          if ($("#headerProfile")) {
            $("#headerProfile").text(data.Profile.UserName + "/" + $("#headerProfile").text().split("/")[1]);
          }

          _this2.GetThumbnailUrl();
        });
      });
    }
    /**
     * プロフィール取得
     */

  }, {
    key: "GetProfileAndDo",
    value: function GetProfileAndDo(callback) {
      var _this3 = this;

      Api.GetProfile(function (data) {
        _this3.setState({
          Profile: data.Profile,
          UserName: data.Profile.UserName,
          UserMailAddress: data.Profile.UserMailAddress,
          UserModalMode: UserModalComponent.Mode.None,
          UserPasswordModalMode: UserPasswordModalComponent.Mode.None,
          UserThumbnailModalMode: UserThumbnailModalComponent.Mode.None,
          UserAvatarModalMode: UserAvatarModalComponent.Mode.None,
          UserRegenerateModalMode: UserRegenerateModalComponent.Mode.None,
          ErrorMessages: []
        }, function () {
          if ($("#headerProfile")) {
            $("#headerProfile").text(data.Profile.UserName + "/" + $("#headerProfile").text().split("/")[1]);
          }

          _this3.GetThumbnailUrl();

          callback();
        });
      });
    }
    /**
     * サムネイル取得
     */

  }, {
    key: "GetThumbnailUrl",
    value: function GetThumbnailUrl() {
      if (!this.state.Profile || !this.state.Profile.UserId || !this.state.Profile.ThumbnailFileName) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        if ($("#headerThumbnail")) {
          $("#headerThumbnail").css("background-image", 'url("/assets/img/user_thumbnail_default.jpg")');
        }

        $("#thumbnailiconframe").css("background-image", 'url("/assets/img/user_thumbnail_default.jpg")');
        return;
      }

      Api.GetThumbnail(this.state.Profile.UserId.toString(), this.state.Profile.ThumbnailFileName, function (blob) {
        if ($("#headerThumbnail")) {
          $("#headerThumbnail").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
        }

        $("#thumbnailiconframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
      });
    }
    /**
     * 「戻る」ボタン押下時の処理を行います。
     */

  }, {
    key: "onBack",
    value: function onBack() {
      var _this4 = this;

      this.props.common.submit(function () {
        _this4.props.common.createAction("Back");
      }, false, true);
    }
    /**
     * ユーザーモーダルを追加で起動します。
     */

  }, {
    key: "openModifyUserModal",
    value: function openModifyUserModal() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        UserModalMode: UserModalComponent.Mode.Profile,
        Profile: {
          UserId: this.state.Profile ? this.state.Profile.UserId : -1,
          UserName: this.state.Profile ? this.state.Profile.UserName : "",
          UserMailAddress: this.state.Profile ? this.state.Profile.UserMailAddress : "",
          Pin: this.state.Profile ? this.state.Profile.Pin : "",
          OrganizationId: this.state.Profile ? this.state.Profile.OrganizationId : -1,
          AuthorityId: this.state.Profile ? this.state.Profile.AuthorityId : -1,
          ThumbnailFileName: this.state.Profile ? this.state.Profile.ThumbnailFileName : "",
          AvatarFileName: this.state.Profile ? this.state.Profile.AvatarFileName : "",
          ConversionStatus: this.state.Profile ? this.state.Profile.ConversionStatus : ConversionStatuses.NoRequest,
          CanSupport: this.state.Profile ? this.state.Profile.CanSupport : 0,
          ContractManagerFlag: this.state.Profile ? this.state.Profile.ContractManagerFlag : false,
          UpdateDateTime: this.state.Profile ? this.state.Profile.UpdateDateTime : "",
          AvatarInfo: this.state.Profile ? this.state.Profile.AvatarInfo : null
        }
      });
    }
    /**
     * ユーザーを登録します。
     */

  }, {
    key: "entryUserModal",
    value: function entryUserModal(userName, userMailAddress, authorityId, canSupport, contractManagerFlag, closeEvent) {
      closeEvent();
    }
    /**
     * ユーザーを更新します。
     */

  }, {
    key: "modifyUserModal",
    value: function modifyUserModal(userId, userName, userMailAddress, organizationId, currentAuthorityId, authorityId, canSupport, contractManagerFlag, updateDateTime, closeEvent) {
      var _this5 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      Api.ModifyUser(userId, userName, userMailAddress, organizationId, authorityId, canSupport, updateDateTime, function (data) {
        if (data.ResultCode == ApiResultCodes.Success) {
          _this5.setState({
            Profile: null
          });

          closeEvent();

          _this5.GetProfile();
        }

        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);
      });
    }
    /**
     * ユーザーを削除します。
     */

  }, {
    key: "deleteUserModal",
    value: function deleteUserModal(userId, updateDateTime) {}
    /**
     * ユーザーモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenUserModal",
    value: function hiddenUserModal() {
      this.setState({
        UserModalMode: UserModalComponent.Mode.None
      });
    }
    /**
     * ユーザーPINモーダルを追加で起動します。
     */

  }, {
    key: "openModifyUserRegenarateModal",
    value: function openModifyUserRegenarateModal() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        UserRegenerateModalMode: UserRegenerateModalComponent.Mode.Regenarate,
        Profile: {
          UserId: this.state.Profile ? this.state.Profile.UserId : -1,
          UserName: this.state.Profile ? this.state.Profile.UserName : "",
          UserMailAddress: this.state.Profile ? this.state.Profile.UserMailAddress : "",
          Pin: this.state.Profile ? this.state.Profile.Pin : "",
          OrganizationId: this.state.Profile ? this.state.Profile.OrganizationId : -1,
          AuthorityId: this.state.Profile ? this.state.Profile.AuthorityId : -1,
          ThumbnailFileName: this.state.Profile ? this.state.Profile.ThumbnailFileName : "",
          AvatarFileName: this.state.Profile ? this.state.Profile.AvatarFileName : "",
          ConversionStatus: this.state.Profile ? this.state.Profile.ConversionStatus : ConversionStatuses.NoRequest,
          CanSupport: this.state.Profile ? this.state.Profile.CanSupport : 0,
          ContractManagerFlag: this.state.Profile ? this.state.Profile.ContractManagerFlag : false,
          UpdateDateTime: this.state.Profile ? this.state.Profile.UpdateDateTime : "",
          AvatarInfo: this.state.Profile ? this.state.Profile.AvatarInfo : null
        }
      });
    }
    /**
     * ユーザーPINを更新します。
     *
     * @param userId ユーザーＩＤ
     */

  }, {
    key: "modifyUserRegenarateModal",
    value: function modifyUserRegenarateModal(userId, updateDateTime, closeEvent) {
      var _this6 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      Api.ResetUserPin(userId, updateDateTime, function (data) {
        if (data.ResultCode == ApiResultCodes.Success) {
          _this6.setState({
            Profile: null
          });

          closeEvent();

          _this6.GetProfile();
        }

        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);
      });
    }
    /**
     * ユーザーPINモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenUserRegenarateModal",
    value: function hiddenUserRegenarateModal() {
      this.setState({
        UserRegenerateModalMode: UserRegenerateModalComponent.Mode.None
      });
    }
    /**
     * ユーザーパスワードモーダルを追加で起動します。
     */

  }, {
    key: "openModifyUserPasswordModal",
    value: function openModifyUserPasswordModal() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        UserPasswordModalMode: UserPasswordModalComponent.Mode.Modify,
        Profile: {
          UserId: this.state.Profile ? this.state.Profile.UserId : -1,
          UserName: this.state.Profile ? this.state.Profile.UserName : "",
          UserMailAddress: this.state.Profile ? this.state.Profile.UserMailAddress : "",
          Pin: this.state.Profile ? this.state.Profile.Pin : "",
          OrganizationId: this.state.Profile ? this.state.Profile.OrganizationId : -1,
          AuthorityId: this.state.Profile ? this.state.Profile.AuthorityId : -1,
          ThumbnailFileName: this.state.Profile ? this.state.Profile.ThumbnailFileName : "",
          AvatarFileName: this.state.Profile ? this.state.Profile.AvatarFileName : "",
          ConversionStatus: this.state.Profile ? this.state.Profile.ConversionStatus : ConversionStatuses.NoRequest,
          CanSupport: this.state.Profile ? this.state.Profile.CanSupport : 0,
          ContractManagerFlag: this.state.Profile ? this.state.Profile.ContractManagerFlag : false,
          UpdateDateTime: this.state.Profile ? this.state.Profile.UpdateDateTime : "",
          AvatarInfo: this.state.Profile ? this.state.Profile.AvatarInfo : null
        }
      });
    }
    /**
     * ユーザーパスワードを更新します。
     *
     * @param userId ユーザーＩＤ
     * @param currentPassword 現在のパスワード
     * @param password 新しいパスワード
     * @param updateDateTime 更新日時
     */

  }, {
    key: "modifyUserPasswordModal",
    value: function modifyUserPasswordModal(userId, currentPassword, password, updateDateTime, fn) {
      var _this7 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        ErrorMessages: []
      }, function () {
        Api.ModifyUserPassword(userId, currentPassword, password, updateDateTime, function (data) {
          if (fn) fn(data);

          if (data.ResultCode == ApiResultCodes.Success) {
            _this7.setState({
              Profile: null
            });

            _this7.GetProfile();
          }

          setTimeout(function () {
            $("#overlay").fadeOut(300);
          }, 500);
        });
      });
    }
    /**
     * ユーザーパスワードモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenUserPasswordModal",
    value: function hiddenUserPasswordModal() {
      this.setState({
        UserPasswordModalMode: UserPasswordModalComponent.Mode.None
      });
    }
    /**
     * ユーザーサムネイルモーダルを起動します。
     */

  }, {
    key: "openUserThumbnailModal",
    value: function openUserThumbnailModal() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        UserThumbnailModalMode: UserThumbnailModalComponent.Mode.Profile,
        Profile: {
          UserId: this.state.Profile ? this.state.Profile.UserId : -1,
          UserName: this.state.Profile ? this.state.Profile.UserName : "",
          UserMailAddress: this.state.Profile ? this.state.Profile.UserMailAddress : "",
          Pin: this.state.Profile ? this.state.Profile.Pin : "",
          OrganizationId: this.state.Profile ? this.state.Profile.OrganizationId : -1,
          AuthorityId: this.state.Profile ? this.state.Profile.AuthorityId : -1,
          ThumbnailFileName: this.state.Profile ? this.state.Profile.ThumbnailFileName : "",
          AvatarFileName: this.state.Profile ? this.state.Profile.AvatarFileName : "",
          ConversionStatus: this.state.Profile ? this.state.Profile.ConversionStatus : ConversionStatuses.NoRequest,
          CanSupport: this.state.Profile ? this.state.Profile.CanSupport : 0,
          ContractManagerFlag: this.state.Profile ? this.state.Profile.ContractManagerFlag : false,
          UpdateDateTime: this.state.Profile ? this.state.Profile.UpdateDateTime : "",
          AvatarInfo: this.state.Profile ? this.state.Profile.AvatarInfo : null
        }
      });
    }
    /**
     * ユーザーサムネイルを更新し、変更のポップアップを再び開く
     * @param userId ユーザーＩＤ
     * @param thumbnail サムネイル
     * @param updateDateTime 更新日時
     */

  }, {
    key: "modifyUserThumbnailAndReopenModal",
    value: function modifyUserThumbnailAndReopenModal(userId, thumbnail, updateDateTime) {
      var _this8 = this;

      this.setState({
        ErrorMessages: []
      }, function () {
        Api.UploadThumbnail(userId, thumbnail, updateDateTime, function (data) {
          _this8.setState({
            Profile: null
          });

          var model = data;

          if (model.ResultCode == ApiResultCodes.LengthError) {
            alert(model.ResultMessage);
          }

          _this8.GetProfileAndDo(function () {
            _this8.openUserThumbnailModal();
          });
        });
      });
    }
    /**
     * ユーザーサムネイルを更新する
     * @param userId ユーザーＩＤ
     * @param thumbnail サムネイル
     * @param updateDateTime 更新日時
     */

  }, {
    key: "modifyUserThumbnail",
    value: function modifyUserThumbnail(userId, thumbnail, updateDateTime) {
      var _this9 = this;

      this.setState({
        ErrorMessages: []
      }, function () {
        Api.UploadThumbnail(userId, thumbnail, updateDateTime, function (data) {
          _this9.setState({
            Profile: null
          });

          var model = data;

          if (model.ResultCode == ApiResultCodes.LengthError) {
            alert(model.ResultMessage);
          }

          _this9.GetProfile();
        });
      });
    }
    /**
     * ユーザーサムネイルを削除します。
     *
     * @param sessionId セッションＩＤ
     * @param updateDateTime 更新日時
     */

  }, {
    key: "deleteUserThumbnailModal",
    value: function deleteUserThumbnailModal(userId, updateDateTime) {
      var _this10 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        ErrorMessages: []
      }, function () {
        Api.DeleteThumbnail(userId, updateDateTime, function () {
          _this10.setState({
            Profile: null
          });

          _this10.GetProfile();

          setTimeout(function () {
            $("#overlay").fadeOut(300);
          }, 500);
        });
      });
    }
    /**
     * ユーザーサムネイルモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenUserThumbnailModal",
    value: function hiddenUserThumbnailModal() {
      this.setState({
        UserThumbnailModalMode: UserThumbnailModalComponent.Mode.None
      });
    }
    /**
     * ユーザーアバターモーダルを起動します。
     */

  }, {
    key: "openUserAvatarModal",
    value: function openUserAvatarModal() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        UserAvatarModalMode: UserAvatarModalComponent.Mode.Profile,
        Profile: {
          UserId: this.state.Profile ? this.state.Profile.UserId : -1,
          UserName: this.state.Profile ? this.state.Profile.UserName : "",
          UserMailAddress: this.state.Profile ? this.state.Profile.UserMailAddress : "",
          Pin: this.state.Profile ? this.state.Profile.Pin : "",
          OrganizationId: this.state.Profile ? this.state.Profile.OrganizationId : -1,
          AuthorityId: this.state.Profile ? this.state.Profile.AuthorityId : -1,
          ThumbnailFileName: this.state.Profile ? this.state.Profile.ThumbnailFileName : "",
          AvatarFileName: this.state.Profile ? this.state.Profile.AvatarFileName : "",
          ConversionStatus: this.state.Profile ? this.state.Profile.ConversionStatus : ConversionStatuses.NoRequest,
          CanSupport: this.state.Profile ? this.state.Profile.CanSupport : 0,
          ContractManagerFlag: this.state.Profile ? this.state.Profile.ContractManagerFlag : false,
          UpdateDateTime: this.state.Profile ? this.state.Profile.UpdateDateTime : "",
          AvatarInfo: this.state.Profile ? this.state.Profile.AvatarInfo : null
        }
      });
    }
    /**
     * ユーザーアバターを作成します。
     *
     * @param userId ユーザーＩＤ
     * @param downloadUrl ダウンロードURL
     * @param updateDateTime 更新日時
     */

  }, {
    key: "createUserAvatarModal",
    value: function createUserAvatarModal(userId, downloadUrl, updateDateTime) {
      var _this11 = this;

      this.setState({
        ErrorMessages: []
      }, function () {
        Api.CreateAvatar(userId, downloadUrl, updateDateTime, function (data) {
          _this11.setState({
            Profile: null
          });

          var model = data;

          if (model.ResultCode == ApiResultCodes.LengthError) {
            alert(model.ResultMessage);
          }

          _this11.GetProfileAndDo(function () {
            _this11.openUserAvatarModal();
          });
        });
      });
    }
    /**
     * ユーザーアバターを更新します。
     *
     * @param userId ユーザーＩＤ
     * @param avator アバター
     * @param updateDateTime 更新日時
     */

  }, {
    key: "modifyUserAvatarModal",
    value: function modifyUserAvatarModal(userId, avator, updateDateTime) {
      var _this12 = this;

      this.setState({
        ErrorMessages: []
      }, function () {
        Api.UploadAvatar(userId, avator, updateDateTime, function (data) {
          _this12.setState({
            Profile: null
          });

          var model = data;

          if (model.ResultCode == ApiResultCodes.LengthError) {
            alert(model.ResultMessage);
          }

          _this12.GetProfileAndDo(function () {
            _this12.openUserAvatarModal();
          });
        });
      });
    }
    /**
     * ユーザーアバターを調整します。
     * @param userId ユーザーＩＤ
     */

  }, {
    key: "adjustUserAvatarModal",
    value: function adjustUserAvatarModal(userId) {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      if (this.waitLoaded > 0) return;
      if (!this.props.common.gameLoad) return;
      $("#normal").hide();
      $("#avatarCustomizer").show();
      this.props.common.gameInstance = this.props.common.gameLoad();

      if (this.props.common.gameLoaded) {
        this.openAdjustUserAvatarModal(userId);
      } else {
        this.waitLoaded = window.setInterval(this.waitingLoaded.bind(this, userId), 500);
      }
    }
    /**
     * ユーザーアバターを調整画面を表示します
     * @param userId ユーザーＩＤ
     */

  }, {
    key: "waitingLoaded",
    value: function waitingLoaded(userId) {
      if (this.props.common.gameLoaded) {
        window.clearInterval(this.waitLoaded);
        this.openAdjustUserAvatarModal(userId);
        this.waitLoaded = 0;
      }
    }
    /**
     * ユーザーアバターを調整画面を表示します
     * @param userId ユーザーＩＤ
     */

  }, {
    key: "openAdjustUserAvatarModal",
    value: function openAdjustUserAvatarModal(userId) {
      var _this13 = this;

      this.GetProfileAndDo(function () {
        var _this13$state$Profile, _this13$state$Profile2, _this13$state$Profile3, _this13$state$Profile4, _this13$state$Profile5, _this13$state$Profile6, _this13$state$Profile7, _this13$state$Profile8, _this13$state$Profile9, _this13$state$Profile10, _this13$state$Profile11, _this13$state$Profile12;

        var data = {
          "Type": "StartViewing",
          "Data": {
            "CommonInfo": {
              "AccessToken": _this13.state.AcessToken
            },
            "UserInfo": {
              "Id": userId,
              "Name": (_this13$state$Profile = _this13.state.Profile) === null || _this13$state$Profile === void 0 ? void 0 : _this13$state$Profile.UserName,
              "AvatarFileName": (_this13$state$Profile2 = _this13.state.Profile) === null || _this13$state$Profile2 === void 0 ? void 0 : _this13$state$Profile2.AvatarFileName,
              "OrganizationId": (_this13$state$Profile3 = _this13.state.Profile) === null || _this13$state$Profile3 === void 0 ? void 0 : _this13$state$Profile3.OrganizationId,
              "AuthorityId": (_this13$state$Profile4 = _this13.state.Profile) === null || _this13$state$Profile4 === void 0 ? void 0 : _this13$state$Profile4.AuthorityId,
              "ThumbnailFileName": (_this13$state$Profile5 = _this13.state.Profile) === null || _this13$state$Profile5 === void 0 ? void 0 : _this13$state$Profile5.ThumbnailFileName,
              "UpdateDateTime": _this13.state.Profile ? ToDateString(Number(_this13.state.Profile.UpdateDateTime)) : ""
            },
            "AvatarInfo": {
              "UserId": userId,
              "AvatarFileName": (_this13$state$Profile6 = _this13.state.Profile) === null || _this13$state$Profile6 === void 0 ? void 0 : _this13$state$Profile6.AvatarFileName,
              "Scale": (_this13$state$Profile7 = _this13.state.Profile) === null || _this13$state$Profile7 === void 0 ? void 0 : (_this13$state$Profile8 = _this13$state$Profile7.AvatarInfo) === null || _this13$state$Profile8 === void 0 ? void 0 : _this13$state$Profile8.Scale,
              "OffsetY": (_this13$state$Profile9 = _this13.state.Profile) === null || _this13$state$Profile9 === void 0 ? void 0 : (_this13$state$Profile10 = _this13$state$Profile9.AvatarInfo) === null || _this13$state$Profile10 === void 0 ? void 0 : _this13$state$Profile10.OffsetY,
              "MaterialPreset": (_this13$state$Profile11 = _this13.state.Profile) === null || _this13$state$Profile11 === void 0 ? void 0 : (_this13$state$Profile12 = _this13$state$Profile11.AvatarInfo) === null || _this13$state$Profile12 === void 0 ? void 0 : _this13$state$Profile12.MaterialPreset,
              "UpdateDateTimeString": _this13.state.Profile && _this13.state.Profile.AvatarInfo ? ToDateString(Number(_this13.state.Profile.AvatarInfo.UpdateDateTime)) : "",
              "UpdateDateTime": _this13.state.Profile && _this13.state.Profile.AvatarInfo ? ToDateString(Number(_this13.state.Profile.AvatarInfo.UpdateDateTime)) : ""
            }
          }
        };
        var dataJson = JSON.stringify(data);

        _this13.props.common.gameInstance.SendMessage("Control", "InvokePageEvent", dataJson);
      });
    }
    /**
     * ユーザーアバターを削除します。
     *
     * @param userId ユーザーＩＤ
     * @param updateDateTime 更新日時
     */

  }, {
    key: "deleteUserAvatarModal",
    value: function deleteUserAvatarModal(userId, updateDateTime) {
      var _this14 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        ErrorMessages: []
      }, function () {
        Api.DeleteAvatar(userId, updateDateTime, function () {
          _this14.setState({
            Profile: null
          });

          _this14.GetProfile();

          setTimeout(function () {
            $("#overlay").fadeOut(300);
          }, 500);
        });
      });
    }
    /**
     * ユーザーアバターモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenUserAvatarModal",
    value: function hiddenUserAvatarModal() {
      this.setState({
        UserAvatarModalMode: UserAvatarModalComponent.Mode.None
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("div", {
        id: "avatarCustomizer",
        style: {
          display: "none"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "Action",
        id: "Action",
        value: "UpdateAvatarInfo"
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "Data",
        id: "Data",
        value: ""
      }), /*#__PURE__*/React.createElement("div", {
        id: "gameContainer"
      }), /*#__PURE__*/React.createElement("div", {
        id: "loader"
      }, /*#__PURE__*/React.createElement("img", {
        className: "bouncing-cube",
        src: "assets/img/whiteroomlogo_cube.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "spinner"
      }), /*#__PURE__*/React.createElement("div", {
        className: "progress"
      }, /*#__PURE__*/React.createElement("div", {
        className: "full"
      })))), /*#__PURE__*/React.createElement("div", {
        id: "normal",
        className: "row"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-6 offset-lg-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modalIcon"
      }, /*#__PURE__*/React.createElement("div", {
        id: "thumbnailiconframe",
        className: "thumbnailicon60frame"
      })), /*#__PURE__*/React.createElement("h2", null, intl.format(Profile.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "UserName"
      }, intl.format(Label.UserName)), /*#__PURE__*/React.createElement("label", {
        className: "col-6 col-form-label"
      }, this.state.Profile ? this.state.Profile.UserName : ""), /*#__PURE__*/React.createElement("a", {
        className: "col-2 col-form-label attribute-change",
        id: "UpdateProfile",
        onClick: this.openModifyUserModal.bind(this),
        tabIndex: 104
      }, intl.format(Action.Change))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "UserMailAddress"
      }, intl.format(Label.MailAddress)), /*#__PURE__*/React.createElement("label", {
        className: "col-6 col-form-label"
      }, this.state.Profile ? this.state.Profile.UserMailAddress : ""), /*#__PURE__*/React.createElement("a", {
        className: "col-2 col-form-label attribute-change",
        id: "PasswordChange",
        onClick: this.openModifyUserPasswordModal.bind(this),
        tabIndex: 105
      }, intl.format(Action.ChangePassword))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Pin"
      }, intl.format(Label.Pin)), /*#__PURE__*/React.createElement("label", {
        className: "col-6 col-form-label"
      }, this.state.Profile ? this.state.Profile.Pin : ""), /*#__PURE__*/React.createElement("a", {
        className: "col-2 col-form-label attribute-change",
        id: "PinRegenarate",
        onClick: this.openModifyUserRegenarateModal.bind(this),
        tabIndex: 106
      }, intl.format(Action.RegenaratePin))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "ThumbnailFileName"
      }, intl.format(Label.Thumbnail)), /*#__PURE__*/React.createElement("label", {
        className: "col-6 col-form-label"
      }, this.state.Profile ? this.state.Profile.ThumbnailFileName : ""), /*#__PURE__*/React.createElement("a", {
        className: "col-2 col-form-label attribute-change",
        id: "ThumbnailChange",
        onClick: this.openUserThumbnailModal.bind(this),
        tabIndex: 107
      }, intl.format(Action.Change))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "AvatarFileName"
      }, intl.format(Label.Avatar)), /*#__PURE__*/React.createElement("label", {
        className: "col-6 col-form-label"
      }, this.state.Profile == null ? intl.format(Avatar.Default) : this.state.Profile.AvatarFileName), /*#__PURE__*/React.createElement("a", {
        className: "col-2 col-form-label attribute-change",
        id: "AvatarChange",
        onClick: this.openUserAvatarModal.bind(this),
        tabIndex: 108
      }, intl.format(Action.Change)))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        key: "onBack",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onBack.bind(this),
        tabIndex: 109
      }, intl.format(Action.Back))))), this.state.UserModalMode != UserModalComponent.Mode.None && /*#__PURE__*/React.createElement(UserModalComponent["default"], {
        mode: this.state.UserModalMode,
        curOrganizationId: NullNumberToBlank(this.state.Profile ? this.state.Profile.OrganizationId : null),
        curUserId: NullNumberToBlank(this.state.Profile ? this.state.Profile.UserId : null),
        curUserAuthorityId: this.state.Profile ? this.state.Profile.AuthorityId : 3,
        domain: "",
        userId: NullNumberToBlank(this.state.Profile ? this.state.Profile.UserId : null),
        userName: this.state.Profile ? this.state.Profile.UserName : "",
        userMailAddress: this.state.Profile ? this.state.Profile.UserMailAddress : "",
        organizationId: NullNumberToBlank(this.state.Profile ? this.state.Profile.OrganizationId : null),
        authorityId: NullNumberToBlank(this.state.Profile ? this.state.Profile.AuthorityId : null),
        thumbnailFileName: this.state.Profile ? this.state.Profile.ThumbnailFileName : "",
        canSupport: NullNumberToBlank(this.state.Profile ? this.state.Profile.CanSupport : null),
        contractManagerFlag: this.state.Profile ? this.state.Profile.ContractManagerFlag : false,
        updateDateTime: this.state.Profile ? this.state.Profile.UpdateDateTime : "",
        onEntry: this.entryUserModal.bind(this),
        onModify: this.modifyUserModal.bind(this),
        onDelete: this.deleteUserModal.bind(this),
        onHidden: this.hiddenUserModal.bind(this)
      }), this.state.UserPasswordModalMode != UserPasswordModalComponent.Mode.None && /*#__PURE__*/React.createElement(UserPasswordModalComponent["default"], {
        mode: this.state.UserPasswordModalMode,
        userId: NullNumberToBlank(this.state.Profile ? this.state.Profile.UserId : null),
        thumbnailFileName: this.state.Profile ? this.state.Profile.ThumbnailFileName : "",
        updateDateTime: this.state.Profile ? this.state.Profile.UpdateDateTime : "",
        onModify: this.modifyUserPasswordModal.bind(this),
        onHidden: this.hiddenUserPasswordModal.bind(this)
      }), this.state.UserThumbnailModalMode != UserThumbnailModalComponent.Mode.None && this.state.Profile && /*#__PURE__*/React.createElement(UserThumbnailModalComponent["default"], {
        mode: this.state.UserThumbnailModalMode,
        isDefault: this.state.Profile.ThumbnailFileName == null,
        userId: NullNumberToBlank(this.state.Profile.UserId),
        thumbnailFileName: this.state.Profile.ThumbnailFileName,
        updateDateTime: this.state.Profile.UpdateDateTime,
        onUpload: this.modifyUserThumbnailAndReopenModal.bind(this),
        onEntry: this.modifyUserThumbnail.bind(this),
        onDefault: this.deleteUserThumbnailModal.bind(this),
        onHidden: this.hiddenUserThumbnailModal.bind(this)
      }), this.state.UserAvatarModalMode != UserAvatarModalComponent.Mode.None && this.state.Profile && /*#__PURE__*/React.createElement(UserAvatarModalComponent["default"], {
        common: this.props.common,
        mode: this.state.UserAvatarModalMode,
        queryRefreshInterval: this.props.queryRefreshInterval,
        isDefault: this.state.Profile.AvatarFileName == null,
        canDelete: false,
        userId: NullNumberToBlank(this.state.Profile.UserId),
        avatarFileName: this.state.Profile.AvatarFileName,
        thumbnailFileName: this.state.Profile.ThumbnailFileName,
        conversionStatus: this.state.Profile.ConversionStatus,
        updateDateTime: this.state.Profile.UpdateDateTime,
        authorityId: this.state.Profile.AuthorityId,
        onCreate: this.createUserAvatarModal.bind(this),
        onModify: this.modifyUserAvatarModal.bind(this),
        onAdjust: this.adjustUserAvatarModal.bind(this),
        onDefault: this.deleteUserAvatarModal.bind(this),
        onHidden: this.hiddenUserAvatarModal.bind(this)
      }), this.state.UserRegenerateModalMode != UserRegenerateModalComponent.Mode.None && this.state.Profile && /*#__PURE__*/React.createElement(UserRegenerateModalComponent["default"], {
        mode: this.state.UserRegenerateModalMode,
        userId: NullNumberToBlank(this.state.Profile.UserId),
        thumbnailFileName: this.state.Profile.ThumbnailFileName,
        updateDateTime: this.state.Profile.UpdateDateTime,
        onRegenerate: this.modifyUserRegenarateModal.bind(this),
        onHidden: this.hiddenUserRegenarateModal.bind(this)
      }));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param queryRefreshInterval 検索リフレッシュインターバル
 */


export default function (el, common, queryRefreshInterval) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    queryRefreshInterval: queryRefreshInterval
  }), el);
}